import React, { useState, useEffect } from 'react';
import "./OurService.css";

const OurService = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className='container our-service-container'>
      <h1>Our <strong>Memories</strong></h1>
      <p>Here you can write something if you want</p>

      <div className="grid-container">
        <div className="grid-item">
          <img src="/AboutUs/chef.png" alt="Image 1" />
        </div>
        <div className="grid-item">
          <img src="/AboutUs/chef.png" alt="Image 2" />
        </div>
        <div className="grid-item">
          <img src="/AboutUs/chef.png" alt="Image 3" />
        </div>
        <div className="grid-item">
          <img src="/AboutUs/chef.png" alt="Image 4" />
        </div>
        <div className="grid-item">
          <img src="/AboutUs/chef.png" alt="Image 5" />
        </div>
        <div className="grid-item">
          <img src="/AboutUs/chef.png" alt="Image 6" />
        </div>
        <div className="grid-item">
          <img src="/AboutUs/chef.png" alt="Image 7" />
        </div>
        <div className="grid-item">
          <img src="/AboutUs/chef.png" alt="Image 8" />
        </div>
        {(windowWidth <= 500 || windowWidth >= 900) && (
          <div className="grid-item">
            <img src="/AboutUs/chef.png" alt="Image 9" />
          </div>
        )}
      </div>

      <h3>Memories Not Ending Here <strong>...</strong></h3>
    </div>
  );
}

export default OurService;
